import api from 'app/api';
import store from 'app/store';
import { convertISOToCustomDateFormat } from '../../utils/commonUtils';

export const getBookingsList = async (params = {}, callback) => {
  const {
   searchText,
   selectedPage,
   pageSize,
 } = params;
 
 const successCallback = ({ data }) => {
   store.dispatch({ type: 'BOOKINGS_LIST:LIST:SET', data: data });

   if (callback) callback(data);
 };

 await api.get(
   `/bookings`,
   {
     id: 'get-bookings-list',
     success: {
       callback: successCallback,
     },
     params: {
       buyerFlow: true,
       start_date: '2024-12-01 00:00:00',
       end_date: convertISOToCustomDateFormat(new Date(Date.now() + (24 * 60 * 60 * 1000))),
       page_no: 0,
       page_size: 100,
       order_by: 'DESC',
       status: ['BOOKED', 'REFUNDED'],
     },
   },
 );
};

export const getBookingRefundInfo = async (smp_id, callback) => {
  const successCallback = ({ data }) => {
    if (callback) callback(data);
  };
  await api.get(
    `/bookings/refund/${smp_id}`,
    {
      id: 'get-booking-refund',
      success: {
        callback: successCallback,
      },
    },
  );
};

export const initiateRefund = async (smp_sale_id, smp_id, successCb, failureCb) => {
  const payload = {
    smp_sale_id: smp_sale_id,
    smp_id: smp_id   
  };
  await api.patch(
    `/events/refund/`, payload,
    {
      id: 'initiate-refund',
      success: {
        callback: successCb,
      },
      failure: {
        callback: failureCb,
      },
    },
  );
};

export const getBookingById = async (id, callback) => {
  const successCallback = ({ data }) => {
    store.dispatch({ type: 'BOOKINGS_LIST:BOOKING_DATA:SET', data: data });

    if (callback) callback(data);
  };

  await api.get(
    `/bookings/${id}`,
    {
      id: 'get-booking',
      success: {
        callback: successCallback,
      },
    },
  );
};

export const resendTickets = async (id, successCb, failureCb) => {
  await api.post(
    `/bookings/resend/${id}`,
    {},
    {
      id: 'resend-tickets',
      success: {
        callback: successCb,
      },
      failure: {
        callback: failureCb,
      },
    },
  );
};
